import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useMemo,
} from 'react';
import { DomainProperty } from '@schamburg-web/interfaces';
import { DataCacheContext } from '../../contexts';

interface DomainContextProps {
  domains: DomainProperty[];
}

export const DomainContext = createContext<DomainContextProps>({
  domains: [],
});

export const DomainProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [domains, setDomains] = React.useState<DomainProperty[]>([]);

  const { createDataCache, sse } = React.useContext(DataCacheContext);
  useEffect(() => {
    if (!sse) {
      return;
    }
    const setObjectsListener = (e: MessageEvent) => {
      setDomains(e.data as DomainProperty[]);
    };
    createDataCache('properties', 10, setObjectsListener);
  }, [createDataCache, setDomains, sse]);

  const contextValue = useMemo(() => ({ domains }), [domains]);

  return (
    <DomainContext.Provider value={contextValue}>
      {children}
    </DomainContext.Provider>
  );
};

export const useDomains = (): DomainContextProps => {
  const context = useContext(DomainContext);
  if (!context) {
    throw new Error('useDomains must be used within a DomainProvider');
  }
  return context;
};
